// Arena / corral panels and gates
//
// Free-standing pipe panels that pin or chain together into an arena or
// round-pen fence. Each product line lists the pieces it is sold in:
//   kind      'panel' or 'gate'
//   lengthFt  nominal length along the fence line. Real panels run a few
//             inches short of nominal (Behlen 4", Sioux Victory 5"); the
//             connector gap makes most of that back, so layouts use nominal.
//   openingFt gates only - the clear walk/ride-through opening
//   heightIn  overall height where a piece differs from the line (gate arches)
// Specs are from manufacturer pages and catalogs, or distributor listings that
// copy them. Prices are distributor list prices seen on PRICES_AS_OF and are
// only a guide; null means not published or not verified.

export const PRICES_AS_OF = '2026-10-02';

export const ARENA_PANEL_PRODUCTS = [
  {
    id: 'generic-5-rail',
    brand: 'Generic',
    line: '5-rail pipe panel',
    heightIn: 60,
    rails: 5,
    tube: '1-5/8" OD round pipe',
    connection: 'Pin & ring or chain',
    notes: 'Use while comparing layouts before choosing a brand.',
    options: [
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "12' panel with 4' walk-through", kind: 'gate', lengthFt: 12, openingFt: 4 },
      { label: "12' gate", kind: 'gate', lengthFt: 12, openingFt: 12 },
    ],
    prices: {},
  },

  // --- Priefert --------------------------------------------------------
  {
    id: 'priefert-premier',
    brand: 'Priefert',
    line: 'Premier Panel',
    heightIn: 64,
    rails: 6,
    tube: '1.66" OD 16 ga Quadraform rails',
    connection: 'Chain',
    sourceUrl: 'https://nrsworld.com/products/priefert-premier-panel-10ft',
    options: [
      { label: "8' panel (PP08)", kind: 'panel', lengthFt: 8 },
      { label: "10' panel (PP10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (PP12)", kind: 'panel', lengthFt: 12 },
      { label: "12' panel with 4' walk-thru (PWT12)", kind: 'gate', lengthFt: 12, openingFt: 4, heightIn: 84 },
      { label: "6' bow gate, 9' bow (PBG069)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
    ],
    prices: { "10' panel (PP10)": 214.40, "12' panel (PP12)": 259.99, "12' panel with 4' walk-thru (PWT12)": 372.80 },
  },
  {
    id: 'priefert-premier-tall',
    brand: 'Priefert',
    line: "Premier Tall Panel (6')",
    heightIn: 72,
    rails: 6,
    tube: '16 ga Quadraform rails',
    connection: 'Rodeo-style pin connectors',
    sourceUrl: 'https://nrsworld.com/products/priefert-panel-12-premier-tall',
    options: [
      { label: "12' panel (PPT12)", kind: 'panel', lengthFt: 12 },
      { label: "6' bow gate, 9' bow (PBGT069)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
      { label: "12' free-swing bow gate (PFS129)", kind: 'gate', lengthFt: 12, openingFt: 12, heightIn: 108 },
    ],
    prices: { "12' panel (PPT12)": 249.99, "6' bow gate, 9' bow (PBGT069)": 433.60, "12' free-swing bow gate (PFS129)": 928.80 },
  },
  {
    id: 'priefert-utility',
    brand: 'Priefert',
    line: 'Utility Panel (horse-safe)',
    heightIn: 62,
    rails: 6,
    tube: '1.66" OD 20 ga round',
    connection: 'Chain',
    sourceUrl: 'https://www.dbsupply.com/12ft-utility-panel-brown-2021713.html',
    options: [
      { label: "12' panel (UP12)", kind: 'panel', lengthFt: 12 },
      { label: "6' utility bow gate (UBG069)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
    ],
    prices: { "12' panel (UP12)": 179.99, "6' utility bow gate (UBG069)": 376.80 },
  },
  {
    id: 'priefert-economy',
    brand: 'Priefert',
    line: 'Economy Round Pen Panel',
    heightIn: 65,
    rails: 6,
    tube: '1.66" OD 20 ga round',
    connection: 'Chain',
    sourceUrl: 'https://nrsworld.com/products/priefert-12-economy-round-panel',
    options: [
      { label: "10' panel (RP10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (RP12)", kind: 'panel', lengthFt: 12 },
      { label: "6' economy bow gate (RBG069)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
    ],
    prices: { "12' panel (RP12)": 129.99, "6' economy bow gate (RBG069)": 228.80 },
  },

  // --- Behlen Country --------------------------------------------------
  {
    id: 'behlen-horse-country-chain',
    brand: 'Behlen Country',
    line: 'Horse Country Corral Panel (chain)',
    heightIn: 64,
    rails: 6,
    tube: '1-5/8" round',
    connection: 'Chain',
    notes: 'Panels run 4" short of nominal length.',
    sourceUrl: 'https://www.behlencountry.com/products/horse-country-corral-panel-chain-connection',
    options: [
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "6' walk-thru", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 90 },
      { label: "4' panel + 6' walk-thru", kind: 'gate', lengthFt: 10, openingFt: 6, heightIn: 90 },
      { label: "6' panel + 6' walk-thru", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 90 },
    ],
    prices: { "12' panel": 169.99 },
  },
  {
    id: 'behlen-horse-country-pin',
    brand: 'Behlen Country',
    line: 'Horse Country Corral Panel (pin)',
    heightIn: 64,
    rails: 6,
    tube: '1-5/8" round',
    connection: 'Drop pin',
    notes: 'Panels run 4" short of nominal length.',
    sourceUrl: 'https://www.behlencountry.com/products/horse-country-corral-panel-pin-connection',
    options: [
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "6' walk-thru", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 90 },
      { label: "4' panel + 6' walk-thru", kind: 'gate', lengthFt: 10, openingFt: 6, heightIn: 90 },
      { label: "6' panel + 6' walk-thru", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 90 },
    ],
    prices: {},
  },
  {
    id: 'behlen-arena-max-xt',
    brand: 'Behlen Country',
    line: 'Arena Max XT Panel',
    heightIn: 72,
    rails: 6,
    tube: '2" round',
    connection: 'Chain',
    sourceUrl: 'https://www.behlencountry.com/products/arena-max-xt-panels',
    options: [
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "6' walk-thru", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 90 },
      { label: "6' walk-thru + 6' panel", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 90 },
    ],
    prices: {},
  },
  {
    id: 'behlen-pioneer',
    brand: 'Behlen Country',
    line: 'Pioneer Corral Panel',
    heightIn: 60,
    rails: 6,
    tube: '1-5/8" round',
    connection: 'Drop pin',
    sourceUrl: 'https://www.behlencountry.com/products/pioneer-corral-panels',
    options: [
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "4' walk-thru", kind: 'gate', lengthFt: 4, openingFt: 4, heightIn: 90 },
      { label: "6' walk-thru", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 90 },
      { label: "6' panel + 6' walk-thru", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 90 },
    ],
    prices: {},
  },
  {
    id: 'behlen-prairie',
    brand: 'Behlen Country',
    line: 'Prairie Panel (medium duty)',
    heightIn: 60,
    rails: 5,
    tube: '16 ga, 1-5/8" round',
    connection: 'Drop pin',
    notes: 'Rail count not published; drawn with 5.',
    sourceUrl: 'https://www.behlencountry.com/products/prairie-panels',
    options: [
      { label: "8' panel", kind: 'panel', lengthFt: 8 },
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "14' panel", kind: 'panel', lengthFt: 14 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "8' panel + 4' walk-thru", kind: 'gate', lengthFt: 12, openingFt: 4, heightIn: 90 },
    ],
    prices: { "12' panel": 249.99 },
  },

  // --- Tarter ----------------------------------------------------------
  {
    id: 'tarter-duratough',
    brand: 'Tarter',
    line: 'DuraTough Panel',
    heightIn: 64,
    rails: 6,
    tube: '1-1/4" x 1-7/8" flat-sided oval',
    connection: 'Dual chain latches',
    notes: 'Bottom rail 10" off the ground. Rail count not published; drawn with 6.',
    sourceUrl: 'https://tarterusa.com/product/duratough-panel/',
    options: [
      { label: "8' panel (DTPBL58)", kind: 'panel', lengthFt: 8 },
      { label: "10' panel (DTPBL510)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (DTPBL512)", kind: 'panel', lengthFt: 12 },
      { label: "14' panel (DTPBL514)", kind: 'panel', lengthFt: 14 },
      { label: "4' walk-thru (DTWTBL74)", kind: 'gate', lengthFt: 4.33, openingFt: 4, heightIn: 92 },
      { label: "12' panel + walk-thru combo (DTWTBL874)", kind: 'gate', lengthFt: 12, openingFt: 4, heightIn: 92 },
      { label: "6' ride-thru (DTRTBL96)", kind: 'gate', lengthFt: 6.33, openingFt: 6, heightIn: 110 },
      { label: "10' panel with ride-thru (DTRTBL910)", kind: 'gate', lengthFt: 10.4, openingFt: 6, heightIn: 110 },
    ],
    prices: {},
  },
  {
    id: 'tarter-american',
    brand: 'Tarter',
    line: 'American Panel (6-bar)',
    heightIn: 62,
    rails: 6,
    tube: '1-3/4" round high-tensile',
    connection: 'Quick-pin latch',
    sourceUrl: 'https://tarterusa.com/product/american-panel-w-walk-thru-2/',
    options: [
      { label: "6' panel (ECR6)", kind: 'panel', lengthFt: 6 },
      { label: "8' panel (ECR8)", kind: 'panel', lengthFt: 8 },
      { label: "10' panel (ECR10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (ECR12)", kind: 'panel', lengthFt: 12 },
      { label: "14' panel (ECR14)", kind: 'panel', lengthFt: 14 },
      { label: "16' panel (ECR16)", kind: 'panel', lengthFt: 16 },
      { label: "4' walk-thru (EWR4)", kind: 'gate', lengthFt: 4, openingFt: 4, heightIn: 95 },
      { label: "6' walk-thru (EWR6)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 95 },
      { label: "6' panel + 4' walk-thru (EWR64)", kind: 'gate', lengthFt: 10, openingFt: 4, heightIn: 95 },
      { label: "6' panel + 6' walk-thru (EWR66)", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 95 },
      { label: "8' panel + 4' walk-thru (EWR84)", kind: 'gate', lengthFt: 12, openingFt: 4, heightIn: 95 },
    ],
    prices: { "12' panel (ECR12)": 156.83, "6' panel + 6' walk-thru (EWR66)": 312.01 },
  },
  {
    id: 'tarter-steelmax',
    brand: 'Tarter',
    line: 'Steelmax Panel (6-bar)',
    heightIn: 62,
    rails: 6,
    tube: '1-3/4" round',
    connection: 'Quick-pin',
    sourceUrl: 'https://tarterusa.com/',
    options: [
      { label: "6' panel (RRC6)", kind: 'panel', lengthFt: 6 },
      { label: "8' panel (RRC8)", kind: 'panel', lengthFt: 8 },
      { label: "10' panel (RRC10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (RRC12)", kind: 'panel', lengthFt: 12 },
      { label: "14' panel (RRC14)", kind: 'panel', lengthFt: 14 },
      { label: "16' panel (RRC16)", kind: 'panel', lengthFt: 16 },
      { label: "4' walk-thru (RRW4)", kind: 'gate', lengthFt: 4, openingFt: 4, heightIn: 95 },
      { label: "6' walk-thru (RRW6)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 95 },
      { label: "6' panel + 4' walk-thru (RRW64)", kind: 'gate', lengthFt: 10, openingFt: 4, heightIn: 95 },
      { label: "8' panel + 4' walk-thru (RRW84)", kind: 'gate', lengthFt: 12, openingFt: 4, heightIn: 95 },
    ],
    prices: {},
  },
  {
    id: 'tarter-bullmax',
    brand: 'Tarter',
    line: 'Bullmax Extra Heavy-Duty Panel',
    heightIn: 62,
    rails: 6,
    tube: '2" 16 ga round high-tensile',
    connection: 'Quick-pin',
    sourceUrl: 'https://nrsworld.com/products/tarter-12ft-2in-6-bar-bullmax-corral-panel',
    options: [
      { label: "10' panel (2RC10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (2RC12)", kind: 'panel', lengthFt: 12 },
      { label: "14' panel (2RC14)", kind: 'panel', lengthFt: 14 },
      { label: "16' panel (2RC16)", kind: 'panel', lengthFt: 16 },
      { label: "4' walk-thru (2WR4)", kind: 'gate', lengthFt: 4, openingFt: 4, heightIn: 96 },
      { label: "6' walk-thru (2WR6)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 96 },
      { label: "6' walk-thru + 6' panel (2WR66)", kind: 'gate', lengthFt: 12, openingFt: 6, heightIn: 96 },
    ],
    prices: { "12' panel (2RC12)": 299.81 },
  },
  {
    id: 'tarter-rough-stock',
    brand: 'Tarter',
    line: 'Rough-Stock Arena Panel',
    heightIn: 72,
    rails: 6,
    tube: '2" 16 ga; 2-3/8" 10 ga bow frames',
    connection: 'Male/female pin',
    notes: 'Rail count not published; drawn with 6.',
    sourceUrl: 'https://tarterusa.com/product/rough-stock-arena-panel/',
    options: [
      { label: "10' panel (SSPA10)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (SSPA12)", kind: 'panel', lengthFt: 12 },
      { label: "16' panel (SSPA16)", kind: 'panel', lengthFt: 16 },
      { label: "4' walk-thru, 7' arch", kind: 'gate', lengthFt: 4, openingFt: 4, heightIn: 84 },
      { label: "6' walk-thru, 7' arch", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 84 },
      { label: "12' drive-thru, 12' arch (SSADT1212)", kind: 'gate', lengthFt: 12, openingFt: 12, heightIn: 144 },
    ],
    prices: {},
  },

  // --- Powder River ----------------------------------------------------
  {
    id: 'powder-river-mountain',
    brand: 'Powder River',
    line: 'Powder Mountain (equine)',
    heightIn: 64,
    rails: 6,
    tube: '1-5/8" 18 ga round',
    connection: 'Pin & clip (horse-safe) or chain',
    sourceUrl: 'https://powderriver.com/products/gates-and-panels/equine-gates-and-panels/powder-mountain-gates-and-panels',
    options: [
      { label: "10' panel", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (015-00012)", kind: 'panel', lengthFt: 12 },
      { label: "16' panel", kind: 'panel', lengthFt: 16 },
      { label: "6' bow gate, 9' bow", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
    ],
    prices: { "12' panel (015-00012)": 219.99 },
  },
  {
    id: 'powder-river-creek',
    brand: 'Powder River',
    line: 'Powder Creek (value equine)',
    heightIn: 64,
    rails: 6,
    tube: '1-5/8" round',
    connection: 'Pin & clip',
    notes: 'Horse use only - not rated for cattle.',
    sourceUrl: 'https://powderriver.com/products/gates-and-panels/equine-gates-and-panels/powder-creek-gates-and-panels',
    options: [
      { label: "12' panel", kind: 'panel', lengthFt: 12 },
      { label: "6' bow gate", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
    ],
    prices: {},
  },

  // --- Sioux Steel -----------------------------------------------------
  {
    id: 'sioux-hiqual-flex',
    brand: 'Sioux Steel',
    line: 'HiQual 6-Rail Flex Panel',
    heightIn: 72,
    rails: 6,
    tube: '1-1/8" x 1-3/4" 16 ga oval',
    connection: 'Rubber Flex Connector (under 1" gap)',
    sourceUrl: 'https://www.siouxsteel.com/explore-our-products/livestock-equipment/gates-panels/square-top-16-gauge-hiqual-panels/hiqual-6-rail-flex-panels',
    options: [
      { label: "10' panel (SHQPNFX10-6)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (SHQPNFX12-6)", kind: 'panel', lengthFt: 12 },
    ],
    prices: {},
  },
  {
    id: 'sioux-victory',
    brand: 'Sioux Steel',
    line: 'Victory 1.5" Panel',
    heightIn: 62,
    rails: 6,
    tube: '1.5" 16 ga hi-tensile round',
    connection: 'Chain latch',
    notes: 'Panels run 5" short of nominal length.',
    sourceUrl: 'https://www.siouxsteel.com/explore-our-products/livestock-equipment/gates-panels/victory-panels/1-66-victory-cattle-panel',
    options: [
      { label: "10' panel (SS1062CP2)", kind: 'panel', lengthFt: 10 },
      { label: "12' panel (SS1262CP2)", kind: 'panel', lengthFt: 12 },
      { label: "14' panel (SS1462CP2)", kind: 'panel', lengthFt: 14 },
      { label: "16' panel (SS1662CP2)", kind: 'panel', lengthFt: 16 },
      { label: "6' bow gate, 9' high (S227896)", kind: 'gate', lengthFt: 6, openingFt: 6, heightIn: 108 },
      { label: "10' bow gate with 4' insert (SS10CPBG2)", kind: 'gate', lengthFt: 10, openingFt: 4, heightIn: 108 },
      { label: "Walk-thru frame with 10' gate (S227880)", kind: 'gate', lengthFt: 10, openingFt: 10, heightIn: 84 },
      { label: "Walk-thru frame with 12' gate (S227881)", kind: 'gate', lengthFt: 12, openingFt: 12, heightIn: 84 },
    ],
    prices: {},
  },
];

export const findPanelProduct = (id) => ARENA_PANEL_PRODUCTS.find(p => p.id === id) || null;
